module.exports = __webpack_public_path__ + "media/images/gallery/constellations/variables_layer_off-4a6ee62e48a05d2a0f08b79d2c4207de.png";